<template>
    <div id="about-page">
        <div class="header">
            <img class="profile-photo" src="@/assets/Sacha-photo.jpg" />
            <div class="content">
                <div class="name">Sacha Goldman</div>
                <div class="titles">He⏐Him</div>
                <div class="icons">
                    <a class="button" :href="decryptedEmail">
                        <img src="@/assets/social_icons/Email.svg" />
                    </a>
                    <!-- <a
                        class="button"
                        rel="noopener noreferrer"
                        href="http://github.com/SachaGoldman"
                        target="_blank"
                    >
                        <img src="@/assets/social_icons/Github.svg" />
                    </a>
                    <a
                        class="button"
                        rel="noopener noreferrer"
                        href="https://twitter.com/_SachaGoldman"
                        target="_blank"
                    >
                        <img src="@/assets/social_icons/Twitter.svg" />
                    </a> -->
                    <!-- <a
                        class="button"
                        rel="noopener noreferrer"
                        href="https://www.linkedin.com/in/sacha-goldman-5b95391a0/"
                        target="_blank"
                    >
                        <img src="@/assets/social_icons/Linkedin.svg" />
                    </a> -->
                </div>
            </div>
        </div>
        <div class="bio">
            <!-- //&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  -->
            I am a PhD student studying mathematics at the University of
            Toronto, supervised by
            <a
                class="link"
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.utsc.utoronto.ca/people/kupers/"
                >Alexander Kupers</a
            >. I am interested in applying tools and techniques from modern
            homotopy theory to study the topology of manifolds.
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import CryptoJS from "crypto-js";

export default defineComponent({
    setup() {
        const decryptedEmail = ref("");

        onMounted(() => {
            getEmail();
        });

        function getEmail() {
            // const ciphertext = CryptoJS.AES.encrypt(
            //     "mailto:sacha.goldman@mail.utoronto.ca",
            //     "poaidsfjiudsafhouWHQe7y91378r"
            // ).toString();

            // console.log(ciphertext);

            decryptedEmail.value = CryptoJS.AES.decrypt(
                "U2FsdGVkX1+Ne4PmmAwsf0HuIfskaull+LGFEIJhmSbs8SCCH7dsqBo/Ye1aAQGnWHE9UH+vcUmEaGaZlhoPRg==",
                "poaidsfjiudsafhouWHQe7y91378r"
            ).toString(CryptoJS.enc.Utf8);
        }

        return { decryptedEmail };
    },
});
</script>

<style lang="scss">
@use "@/assets/global";

#about-page {
    margin-left: global.$side-margin-width;
    margin-right: global.$side-margin-width;
    margin-bottom: global.$top-margin-width;

    .header {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        justify-content: center;
        flex-wrap: wrap;
    }

    .profile-photo {
        margin-bottom: 40px;
        margin-top: 20px;
        margin-right: 40px;
        margin-left: 40px;

        max-height: 300px;

        border: global.$image-border-width solid global.$accent-color;
        @media (prefers-color-scheme: dark) {
            border: global.$image-border-width solid
                global.$dark-theme-accent-color;
        }
        border-radius: global.$image-border-radius;

        @media all and (max-width: global.$mobile-width) {
            max-width: 100%;
        }

        @media not all and (max-width: global.$mobile-width) {
            max-width: 30%;
        }
    }

    .content {
        margin-bottom: 40px;

        @media all and (max-width: global.$mobile-width) {
            width: 100%;
        }

        @media not all and (max-width: global.$mobile-width) {
            width: calc(70% - 40px);
        }
    }

    .name {
        color: global.$bold-text-color;
        @media (prefers-color-scheme: dark) {
            color: global.$dark-theme-bold-text-color;
        }
        font-size: 3.5rem;
        line-height: 4rem;
    }

    .titles {
        font-size: 1.35rem;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .icons {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        color: global.$accent-color;
        @media (prefers-color-scheme: dark) {
            color: global.$dark-theme-accent-color;
        }
    }

    .button {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        width: 40px;
        height: 40px;

        margin-right: 15px;
        margin-top: 10px;

        padding: 0px;

        border: none;
        border-radius: 20px;

        outline: none;

        background-color: global.$accent-color;
        @media (prefers-color-scheme: dark) {
            background-color: global.$dark-theme-accent-color;
        }

        &:hover {
            transform: scale(1.15);
            transition-property: transform;
            transition-duration: 75ms;
        }

        img {
            width: 24px;
        }
    }

    .bio {
        @media not all and (max-width: global.$mobile-width) {
            text-align: justify;
        }
    }
}
</style>
